import { render } from "./ScreenSeeMoreLabelWithButtons.vue?vue&type=template&id=3dcb84d0&scoped=true&ts=true"
import script from "./ScreenSeeMoreLabelWithButtons.vue?vue&type=script&lang=ts"
export * from "./ScreenSeeMoreLabelWithButtons.vue?vue&type=script&lang=ts"

import "./ScreenSeeMoreLabelWithButtons.vue?vue&type=style&index=0&id=3dcb84d0&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcb84d0"]])

export default __exports__